<template>
  <v-layout class="headline font-weight-light blue-grey--text">
    <v-flex>
      <v-layout align-center justify-center fill-height>
        <v-flex class="text-xs-center">
          <!-- The info message -->
          <span v-if="!loadingCategories && !loadingClassifications">{{ message }}</span>
          <!-- A spinner to show while loading the products -->
          <v-pulse-loader v-else loading />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";

import VPulseLoader from "vue-spinner/src/PulseLoader";

export default {
  components: {
    VPulseLoader
  },
  computed: {
    ...mapState("classifier", [
      "currentClassification",
      "loadingCategories",
      "loadingClassifications"
    ]),
    message() {
      if (this.currentClassification) {
        return `Al parecer no hay predicciones en la clasificación ${this.currentClassification.id}`;
      }

      return "Para ver predicciones por favor selecciona una clasificación.";
    }
  }
};
</script>